import { ERROR_MESSAGES } from 'constants/errorMessages';


export interface MessagesType {
  load_payment_blocked: string,
  cash_limit_my_wallet: string,
  semi_close_checkout_page_msg: string,
  semi_close_otp_fails_msg: string,
}

/**
 * @description
 * transformer for messages for wallet transactions
 * @param messages - messages from wallet api
 */
export const transformMessages = (messages:MessagesType) => {
  if (!messages) {
    return {
      loadPaymentBlocked: ERROR_MESSAGES.WALLET_UNAVAILABLE,
    };
  }

  return {
    loadPaymentBlocked: messages.load_payment_blocked
      || ERROR_MESSAGES.WALLET_UNAVAILABLE,
    cashLimitMyWallet: messages.cash_limit_my_wallet || '',
    semiCloseWalletMessages: {
      info: messages.semi_close_checkout_page_msg || '',
      failure: messages.semi_close_otp_fails_msg || '',
    },
  };
};
